import axios from 'axios';
import WebApi from '../WebApi';
class TechniciansApi extends WebApi {
    async getTechnicianData({ id }) {
        return axios.get(`${this.urlPrefix}/account_onboarding/technicians/${id}`, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
    }
    async getTechnicians(payload) {
        const urlParams = `?pagination[per_page]=${payload.per_page}&pagination[page]=${payload.current_page}`;
        return axios.get(`${this.urlPrefix}/account_onboarding/technicians${urlParams}`, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
    }
    // eslint-disable-next-line max-len
    async createTechnician({ email, first_name, label, last_name, kind, company_id, company_admin, phone, skill_ids, departure_point, set_company_as_starting_point, geo_site_ids }) {
        return axios.post(`${this.urlPrefix}/account_onboarding/technicians`, {
            'technician': {
                email,
                first_name,
                last_name,
                label,
                kind,
                company_id,
                company_admin,
                phone,
                skill_ids,
                departure_point,
                set_company_as_starting_point,
                geo_site_ids,
            },
        }, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
    }
    // eslint-disable-next-line max-len
    async editTechnician({ email, first_name, label, last_name, kind, company_id, company_admin, phone, skill_ids, departure_point, set_company_as_starting_point, geo_site_ids }, workerId) {
        return axios.put(`${this.urlPrefix}/account_onboarding/technicians/${workerId}`, {
            'technician': {
                email,
                first_name,
                last_name,
                kind,
                company_id,
                phone,
                company_admin,
                skill_ids,
                departure_point,
                set_company_as_starting_point,
                geo_site_ids,
            },
        }, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
    }
    async deleteTechnician({ id }) {
        return axios.delete(`${this.urlPrefix}/account_onboarding/technicians/${id}`, {
            data: {},
            headers: {
                'Content-Type': 'application/json',
            },
        });
    }
}
const techniciansApi = new TechniciansApi();
export { techniciansApi as TechniciansApi, };
